import type { ReactNode } from 'react';

import { Box, Stack, SxProps, Theme, Typography } from '@mui/material';

import CopyToClipboardButton from '../../../components/Clipboard/CopyToClipboardButton';

interface FlowInstanceDetailRowProps {
	label: string;
	value: ReactNode;
	copyValue?: string;
	copyTitle?: string;
	monospace?: boolean;
	labelWidth?: string;
	valueSx?: SxProps<Theme>;
}

export default function FlowInstanceDetailRow({
	label,
	value,
	copyValue,
	copyTitle,
	monospace = false,
	labelWidth = '120px',
	valueSx,
}: FlowInstanceDetailRowProps) {
	return (
		<Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 1.5 }}>
			<Typography variant="body2" color="textSecondary" sx={{ minWidth: labelWidth }}>
				{label}
			</Typography>
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, minWidth: 0, flex: 1 }}>
				<Typography
					variant="body2"
					sx={[
						{
							fontFamily: monospace ? 'monospace' : undefined,
							fontSize: monospace ? '0.75rem' : undefined,
							wordBreak: monospace ? 'break-all' : undefined,
						},
						...(Array.isArray(valueSx) ? valueSx : [valueSx]),
					]}
				>
					{value}
				</Typography>
				{copyValue && <CopyToClipboardButton value={copyValue} title={copyTitle} size="small" iconSize={12} edge={false} sx={{ p: 0.5 }} />}
			</Box>
		</Stack>
	);
}
